/**
 * Config options
 * min - number,
 * max - number,
 * step - number,
 * digits - number,
 * speedStep - number,
 * strictValidation - boolean, default=true, pass to keyboard min/max validation rules
 * label - string, default='Amount'
 * valueType - string, default='currency',
 * valueLabel - string, default='',
 * buttons - boolean, default=true,
 * readonly - boolean, default=false,
 * currencySign - string, default='$'
 * viewName - string, input amount title, default=''
 */
appSocial.directive('inputAmount', ['$timeout',
    function ($timeout) {
        return {
            templateUrl: 'shared/directives/input-amount/InputAmount.html',
            restrict: 'E',
            require: {ngModelCtrl: 'ngModel'},
            bindToController: true,
            controllerAs: '$ctrl',
            bindings: {
                ngModel: '<'
            },
            scope: {
                config: '=',
                onChange: '&',
            },
            controller: class InputAmountComponent {
                constructor($scope) {
                    this.$scope = $scope;
                    this.model = {
                        value: 0
                    }

                    this.keyboardModelName = null;
                    this.isKeyboardShow = false;

                    this.defaultConfig = {
                        min: 0,
                        max: 999999,
                        step: 1,
                        digits: 0,
                        speedStep: 10,
                        label: 'Amount',
                        currencySign: '$',
                        valueType: 'currency',
                        valueLabel: '',
                        buttons: true,
                        readonly: false,
                        viewName: '',
                        strictValidation: true
                    }

                    this.modelWatch = $scope.$watch(
                        () => this.model.value,
                        () => this.onChange(this.model)
                    )
                }

                $onInit() {
                    this.config = _.merge(this.defaultConfig, this.config);

                    return $timeout(() => {
                        if (!this.ngModelCtrl.$modelValue.hasOwnProperty('value')) {
                            throw new Error('Input model should be an object with \'value\' field!');
                        }

                        if (typeof this.ngModelCtrl.$modelValue.value !== 'number') {
                            throw new Error('Input model is not a number!');
                        }

                        this.model = this.ngModelCtrl.$modelValue;

                        this.keyboardModelName = null;
                    }, 0)
                }

                $onDestroy() {
                    this.closeKeyboard();
                    this.modelWatch && this.modelWatch();
                }

                inputFocus(model, name) {
                    if (this.config.readonly) {
                        return;
                    }

                    this.isKeyboardShow = true;
                    this.keyboardModelName = {
                        model: model,
                        name: name,
                        minval: this.config.strictValidation ? this.config.min : 0,
                        maxval: this.config.strictValidation ? this.config.max : 10000000,
                        digits: this.config.digits,
                        viewName: this.config.viewName,
                    };
                };

                onKeyboardClose(arg) {
                    if (!arg) {
                        //close keyboard
                        this.closeKeyboard();
                        return;
                    }

                    // apply changes to model
                    this.model.value = Number(arg.model.value);
                    this.closeKeyboard();
                };

                closeKeyboard() {
                    this.isKeyboardShow = false;
                    this.keyboardModelName = null;
                }

                onClick(direction) {
                    console.log('Got click', direction);
                }
            }
        }
    }
])
